import React, { useState } from "react";
import "./component.css";
import leftArrow from "../../assests/leftArrow.svg";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment-timezone";
import emotions7 from "../../assests/emotions7.svg";
import LoadingSpinner from "../Loading/component";

const ComboListComponent = (props) => {
  const navigate = useNavigate();
  // console.log("combo id", comboId)
  const handleClick = () => navigate("/");

  const newComboCreation = () => {
    navigate("/home/comboCreation");
  };

  const handleComboDetails = (comboId) => {
    navigate(`/home/combodetails/${comboId}`);
  };

  return (
    <>
      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="comboListContainer">
          <div className="header">
            <div className="headerLeft">
              <img
                onClick={handleClick}
                style={{ width: "22px", cursor: "pointer" }}
                src={leftArrow}
                alt="Back"
              />
              <h2>Combo</h2>
            </div>
            <input
              type="text"
              placeholder="Search combo by ID/Name"
              value={props.searchTerm || ""}
              onChange={(e) => {
                const value = e.target.value || "";
                props.setSearchTerm(value);
                props.SearchCombosApi(value);
              }}
              className="searchBar"
            />
            <button className="createButton" onClick={newComboCreation}>
              Create Combo
            </button>
          </div>

          <div className="content">
            <div className="filters">
              <button
                onClick={() => props.handleClearAllFilter()}
                className="clearButton"
              >
                Clear All
              </button>
              <div>
                <h4 style={{ fontFamily: "Roboto" }}>Status</h4>
                <div style={{ display: "flex" }}>
                  <input
                    style={{
                      height: "20px",
                      width: "18px",
                      border: "1px solid #28a745",
                      color: "#28a745 !important",
                      variant: "outlined",
                      cursor: "pointer",
                    }}
                    type="checkbox"
                    name="status"
                    value="Active"
                    checked={props.comboStatusFilter.includes("Active")}
                    onChange={() => props.toggleComboStatusFilter("Active")}
                  />
                  <p style={{ marginLeft: "16px" }}>
                    <span className="comboStatusActive">Active</span>
                  </p>
                </div>
                <div style={{ display: "flex" }}>
                  <input
                    style={{
                      height: "20px",
                      width: "18px",
                      border: "1px solid #28a745",
                      color: "#28a745 !important",
                      variant: "outlined",
                      cursor: "pointer",
                    }}
                    type="checkbox"
                    name="status"
                    value="Inactive"
                    checked={props.comboStatusFilter.includes("Inactive")}
                    onChange={() => props.toggleComboStatusFilter("Inactive")}
                  />
                  <p style={{ marginLeft: "16px" }}>
                    <span className="comboStatausIn">Inactive</span>
                  </p>
                </div>

                <h4 style={{ fontFamily: "Roboto" }}>Sort By</h4>
                <div style={{ display: "flex" }}>
                  <input
                    style={{
                      height: "20px",
                      width: "18px",
                      border: "1px solid #28a745",
                      color: "#28a745 !important",
                      variant: "outlined",
                      cursor: "pointer",
                    }}
                    type="checkbox"
                    name="sort"
                    value="priceHighToLow"
                    checked={props.sortOption === "priceHighToLow"}
                    onChange={() =>
                      props.setSortOption(
                        props.sortOption === "priceHighToLow"
                          ? ""
                          : "priceHighToLow"
                      )
                    }
                  />
                  <p style={{ marginLeft: "16px" }}>Price (high to low)</p>
                </div>
                <div style={{ display: "flex" }}>
                  <input
                    style={{
                      height: "20px",
                      width: "18px",
                      border: "1px solid #28a745",
                      color: "#28a745 !important",
                      variant: "outlined",
                      cursor: "pointer",
                    }}
                    type="checkbox"
                    name="sort"
                    value="priceLowToHigh"
                    checked={props.sortOption === "priceLowToHigh"}
                    onChange={() =>
                      props.setSortOption(
                        props.sortOption === "priceLowToHigh"
                          ? ""
                          : "priceLowToHigh"
                      )
                    }
                  />
                  <p style={{ marginLeft: "16px" }}>Price (low to high)</p>
                </div>

                <div style={{ display: "flex" }}>
                  <input
                    style={{
                      height: "20px",
                      width: "18px",
                      border: "1px solid #28a745",
                      color: "#28a745 !important",
                      variant: "outlined",
                      cursor: "pointer",
                    }}
                    type="checkbox"
                    name="sort"
                    value="aToZ"
                    checked={props.sortOption === "aToZ"}
                    onChange={() =>
                      props.setSortOption(
                        props.sortOption === "aToZ" ? "" : "aToZ"
                      )
                    }
                  />
                  <p style={{ marginLeft: "16px" }}>A to Z</p>
                </div>
                <div style={{ display: "flex" }}>
                  <input
                    style={{
                      height: "20px",
                      width: "18px",
                      border: "1px solid #28a745",
                      color: "#28a745 !important",
                      variant: "outlined",
                      cursor: "pointer",
                    }}
                    type="checkbox"
                    name="sort"
                    value="zToA"
                    checked={props.sortOption === "zToA"}
                    onChange={() =>
                      props.setSortOption(
                        props.sortOption === "zToA" ? "" : "zToA"
                      )
                    }
                  />
                  <p style={{ marginLeft: "16px" }}>Z to A</p>
                </div>
              </div>
            </div>
            <div className="comboGrid">
              {props.combos.length > 0 ? (
                props.combos.map((combo) => (
                  <div
                    key={combo.id}
                    className={`comboCard ${
                      !combo.isActive ? "disabled" : "enabled"
                    }`}
                    onClick={() => handleComboDetails(combo.id)}
                  >
                    <div className="imageContainer">
                      {combo.image_url && combo.image_url.length > 0 && (
                        <img
                          alt="No image available"
                          src={`https://s3.ap-south-1.amazonaws.com/daalchini/dcprod/${combo.image_url}`}
                          className="comboImage"
                        />
                      )}
                    </div>
                    <h4>{combo.name}</h4>
                    <p>{combo.description}</p>
                    <div className="priceContainer">
                      <div style={{ display: "flex" }}>
                        <p className="actualPrice">₹{combo.actual_price}</p>
                        <p className="totalPrice">₹{combo.total_price}</p>
                      </div>
                      <p className="comboId">ID: {combo.id}</p>
                    </div>
                    <p className="expiryDate">
                      Expiry Date:{" "}
                      {moment
                        .utc(combo.expires_at)
                        .tz("Asia/Kolkata")
                        .format("YYYY-MM-DD")}
                    </p>
                  </div>
                ))
              ) : (
                <div className="noResult">
                  <div className="Nocomboimage">
                    <img src={emotions7} alt="" />
                    <p> No combos found</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ComboListComponent;
